import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CollectionsService} from '../../../collections/service/collections.service';
import {CartService} from '../../../cart/services/cart.service';
import {Subscription} from 'rxjs';
import i18next from 'i18next';
import {getCurrencySymbol} from '@angular/common';

@Component({
  selector: 'app-matching-products',
  templateUrl: './matching-products.component.html',
  styleUrls: ['./matching-products.component.scss']
})
export class MatchingProductsComponent implements OnInit {
  @Input() crossSellingProducts: any[] = [];
  collectionId: string;
  route = '';
  public priceActive = false;
  public lang!: string;
  currencySymbol!: string;
  private subscription: Subscription = new Subscription();

  constructor(private activatedRoute: ActivatedRoute, private router: Router, public collectionsService: CollectionsService, private cartService: CartService) {
    // Liest Url parameter, id/CollectionID , aus
    this.collectionId = this.activatedRoute.snapshot.params.id;
    // Subscriber zum Ein- und Ausblenden des Preises
    const priceActiveSub = this.cartService.priceActive$.subscribe((value) => {
      this.priceActive = value;
    });
    this.subscription.add(priceActiveSub);
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    // Setzt Währungssymbol je nach Sprache
    this.currencySymbol = getCurrencySymbol(this.collectionsService.currencyCode, 'narrow');
    // aktuelle Sprache
    this.lang = i18next.language;
    // aktuelle Route
    this.route = '/collections/collection-detail/' + this.collectionId + '/product/';
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
